import { createSelector } from '@ngrx/store';
import { selectSalesLocationsState } from '../reducers';
import * as fromCxSalesLocation from '../reducers/cx-sales-location.reducer';
import { CxSalesLocation } from '../../models/sales-location';

export const selectCxSalesLocations = createSelector(selectSalesLocationsState, fromCxSalesLocation.selectAll);
export const selectCxSalesLocationIds = createSelector(selectSalesLocationsState, fromCxSalesLocation.selectIds);
export const selectCxSalesLocationEntities = createSelector(
  selectSalesLocationsState,
  fromCxSalesLocation.selectEntities,
);
export const selectCxSalesLocationTotal = createSelector(selectSalesLocationsState, fromCxSalesLocation.selectTotal);
export const selectCxSalesLocationById = () =>
  createSelector(selectCxSalesLocationEntities, (cxSalesLocationEntities, { id }) => cxSalesLocationEntities[id]);
export const selectCxSalesLocationsById = () =>
  createSelector(
    selectCxSalesLocationEntities,
    (cxShipmentLocationEntities, { ids }) =>
      ids.map((id) => cxShipmentLocationEntities[id]).filter(Boolean) as CxSalesLocation[],
  );
export const selectActiveCxSalesLocationId = createSelector(
  selectSalesLocationsState,
  fromCxSalesLocation.selectActiveEntityId,
);
export const selectActiveCxSalesLocation = createSelector(
  selectCxSalesLocationEntities,
  selectActiveCxSalesLocationId,
  (cxSalesLocationEntities, id) => id && cxSalesLocationEntities[id],
);
